export const dmsEs = {
  archive: {
    title: 'Archivo de documentos',
    subtitle: 'Archivo central para documentos generales, contratos, registros y plantillas.',
  },
  manager: {
    title: 'Documentos y archivos',
    description: 'Archivos protegidos con sumas de verificación y un historial trazable.',
  },
  upload: {
    dropTitle: 'Suelte archivos aquí o selecciónelos',
    dropHint: 'PDF, JPG, PNG, WebP, TXT, CSV, DOCX o XLSX · hasta 50 MB por archivo',
    select: 'Seleccionar archivos',
    categoryHint: 'La categoría seleccionada se aplica a todos los archivos de esta carga.',
    success_one: '{{count}} archivo cargado.',
    success_other: '{{count}} archivos cargados.',
  },
  search: { label: 'Buscar documentos', placeholder: 'Nombre, título o etiqueta …' },
  fields: {
    title: 'Nombre para mostrar',
    category: 'Categoría',
    tags: 'Etiquetas (separadas por comas)',
    description: 'Descripción / nota',
  },
  portal: {
    label: 'Compartir en el portal del cliente',
    hint: 'Solo los archivos compartidos expresamente son visibles para los usuarios de este cliente.',
    visible: 'Visible en el portal',
  },
  categories: {
    GENERAL_FILE: 'Archivo general',
    CONTRACT: 'Contrato',
    CERTIFICATE: 'Certificado',
    DATASHEET: 'Hoja de datos',
    INVOICE_RECEIPT: 'Factura / recibo',
    CORRESPONDENCE: 'Correspondencia',
    CUSTOMS_DECLARATION: 'Declaración de aduana',
    IMAGE: 'Imagen',
  },
  actions: {
    preview: 'Vista previa',
    previewNamed: 'Abrir vista previa de {{name}}',
    download: 'Descargar',
  },
  item: { uploaded: '{{date}} · {{user}}' },
  empty: {
    title: 'Aún no hay archivos',
    description: 'Agrega los primeros documentos usando arrastrar y soltar.',
    search: 'Ningún documento coincide con tu búsqueda.',
  },
  edit: { title: 'Editar documento', success: 'Detalles del documento guardados.' },
  delete: {
    title: '¿Eliminar documento permanentemente?',
    description:
      '“{{name}}” se eliminará del archivo y del almacenamiento protegido. La operación permanecerá en el registro de auditoría.',
    success: 'Documento eliminado.',
  },
  preview: {
    error: 'No se pudo cargar la vista previa.',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    page: 'Página',
    zoom: 'Zoom',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    rotateLeft: 'Girar a la izquierda',
    rotateRight: 'Girar a la derecha',
    fullscreen: 'Pantalla completa',
    textTruncated: 'La vista previa del texto se acortó para mantener la respuesta del visor.',
    uploadedAt: 'Subido en {{date}}',
  },
  errors: {
    list: 'No se pudieron cargar los documentos.',
    download: 'Descarga fallida.',
    entityMissing: 'La entidad ERP relacionada no existe.',
    size: '“{{name}}” está vacío o es mayor de 50 MB.',
    uploadFile: 'No se pudo subir “{{name}}”.',
  },
  tabs: {
    partner: 'Documentos y contratos',
    product: 'Archivos y hojas de datos',
    documentDetails: 'Datos del documento',
    documentAttachments: 'Adjuntos',
  },
  batch: {
    title: 'Documentos por lote',
    subtitle: '{{product}} · Lote {{batch}}',
    back: 'Volver al producto',
    filesTitle: 'Certificados de análisis e informes de laboratorio',
    loadError: 'No se pudo cargar el lote.',
  },
} as const;
